import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import 'rxjs/add/operator/finally';
import { environment } from "../../../environments/environment";
import { Locality } from "../models";

@Injectable()
export class GeocodingService {

    constructor(private http: HttpClient) { }

    inverseGeoconding(latitude: number, longitude: number, zoom: number): Observable<any> {
        return this.http.get(environment.nominatim_dns + 'reverse.php?format=json&lat=' + latitude + '&lon=' + longitude + '&zoom=' + zoom + '&accept-language=fr&addressdetails=1');
    }
}